(() => {
  class CountdownReel extends CountdownTimer {
    constructor() {
      super();
      this.daysEl = null;
    }

    connectedCallback() {
      if (this.dataset.countdownInit === "true") return;
      this.dataset.countdownInit = "true";

      const endValue = this.getAttribute("data-countdown-end");
      if (!endValue) return;

      const endTime = new Date(endValue.replace(" ", "T"));
      if (Number.isNaN(endTime.getTime())) return;

      this.endTime = endTime;
      this.daysEl = this.querySelector("[data-countdown-days]");
      this.hoursEl = this.querySelector("[data-countdown-hours]");
      this.minutesEl = this.querySelector("[data-countdown-minutes]");
      this.secondsEl = this.querySelector("[data-countdown-seconds]");

      this.updateCountdown = this.updateCountdown.bind(this);
      this.updateCountdown();
      this.timerId = setInterval(this.updateCountdown, 1000);
    }

    updateCountdown() {
      if (!this.endTime) return;

      const diff = Math.max(0, this.endTime.getTime() - Date.now());
      const hasDays = Boolean(this.daysEl);
      const days = hasDays ? Math.floor(diff / 86400000) : 0;
      const hours = hasDays
        ? Math.floor((diff % 86400000) / 3600000)
        : Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      if (this.daysEl) {
        this.updateUnit(this.daysEl, days);
      }
      if (this.hoursEl) {
        this.updateUnit(this.hoursEl, hours);
      }
      if (this.minutesEl) {
        this.updateUnit(this.minutesEl, minutes);
      }
      if (this.secondsEl) {
        this.updateUnit(this.secondsEl, seconds);
      }

      if (diff <= 0 && this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
    }

    updateUnit(unitEl, value) {
      const prev = unitEl.querySelector("[data-countdown-prev]");
      const current = unitEl.querySelector("[data-countdown-current]");
      const nextValue = String(value).padStart(2, "0");

      if (!prev || !current) {
        unitEl.textContent = nextValue;
        unitEl.dataset.value = nextValue;
        return;
      }

      const existing = unitEl.dataset.value;
      if (!existing) {
        prev.textContent = nextValue;
        current.textContent = nextValue;
        unitEl.dataset.value = nextValue;
        return;
      }

      if (existing === nextValue) return;

      prev.textContent = existing;
      current.textContent = nextValue;
      unitEl.dataset.value = nextValue;

      unitEl.classList.remove("animate-reel");
      void unitEl.offsetWidth;
      unitEl.classList.add("animate-reel");

      if (unitEl.reelTimeoutId) {
        clearTimeout(unitEl.reelTimeoutId);
      }
      unitEl.reelTimeoutId = setTimeout(() => {
        unitEl.classList.remove("animate-reel");
      }, 600);
    }
  }

  if (!customElements.get("countdown-reel")) {
    customElements.define("countdown-reel", CountdownReel);
  }
})();
